<template>
  <div class="quality-trace-container">
    <div class="quality-trace" id="quality-trace">
       <div class="section-header">
        <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
        <div class="header-title">品质溯源</div>
         <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
      </div>
      <div class="trace-list">
        <div v-for="(item, index) in traceList" :key="index" class="trace-item">
          <div class="trace-image">
            <img :src="item.image" :alt="item.title" />
          </div>
          <div class="trace-content">
            <div class="trace-step-title">{{ item.title }}</div>
            <div class="trace-step-operator">操作人：<span>{{ item.operator }}</span></div>
            <div class="trace-step-time">操作时间：<span>{{ item.time }}</span></div>
            <div class="trace-step-tags">
              <div class="trace-step-tag" @click="openProcessDialog(item)">
                <img src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115164844A015.png" alt="">
                <span>加工生产记录</span>
              </div>
              <div class="trace-step-tag">
                <img src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115164905A016.png" alt="">
                <span>时间戳</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 加工生产记录弹窗 -->
    <div v-if="showProcessDialog" class="process-dialog-overlay" @click="closeProcessDialog">
      <div class="process-dialog" @click.stop>
        <!-- 弹窗标题栏 -->
        <div class="dialog-header">
          <div class="dialog-title">{{ currentTrace?.title }}</div>
          <div class="dialog-close" @click="closeProcessDialog">
            <img src="https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120100845A001.png" alt="关闭">
          </div>
        </div>
        
        <!-- 弹窗内容 -->
        <div class="dialog-content">
          <!-- 操作信息 -->
        <div class="process-info">
          <div class="info-item">操作人：<span>{{ currentTrace?.operator }}</span></div>
          <div class="info-item">操作时间：<span>{{ currentTrace?.time }}</span></div>
        </div>
        
        <!-- 图片展示区域 -->
        <div class="image-container">
          <div class="image-wrapper" v-if="currentTrace?.imageUrls && currentTrace.imageUrls.length > 0">
            <img 
              :src="currentTrace.imageUrls[currentImageIndex] || 'https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115163920A013.png'" 
              :alt="currentTrace?.title"
              class="process-image"
            >
            
            <!-- 图片切换按钮 -->
            <div class="image-nav" v-if="currentTrace.imageUrls.length > 1">
              <div class="nav-btn prev" @click="switchImage('prev')">&lt;</div>
              <div class="nav-btn next" @click="switchImage('next')">&gt;</div>
            </div>
          </div>
          <div class="no-records" v-else>
            暂无加工生产记录
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import traceApi from '@/api/modules/trace'

export default {
  name: 'QualityTrace',
  props: {
    batch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      traceList: [],
      // 弹窗相关数据
      showProcessDialog: false,
      currentTrace: null,
      currentImageIndex: 0,
      loading: false
    }
  },
  mounted() {
    this.getTraceList()
  },
  methods: {
    // 将图片字符串转换为数组
    parseImageString(imageString) {
      if (!imageString) return []
      // 假设图片URL之间用逗号分隔，可根据实际情况调整分隔符
      return imageString.split(',').map(url => url.trim()).filter(url => url)
    },
    
    // 获取溯源列表
    async getTraceList() {
      try {
        this.loading = true
        // 第一步：调用溯源码列表接口获取数据，传递 batch 参数
        const codeResponse = await traceApi.getCodeList({
          pageNum: 1,
          pageSize: 20,
          batch: this.batch
        })
        
        if (codeResponse.success && codeResponse.data && codeResponse.data.records && codeResponse.data.records.length > 0) {
          // 第二步：使用溯源码 id 调用加工生产记录接口
          const codeId = codeResponse.data.records[0].id
          const processResponse = await traceApi.getCodeProcessRecords({
            pageNum: 1,
            pageSize: 20,
            codeId: codeId
          })
          
          // 第三步：将加工生产记录数据作为 traceList 展示
          if (processResponse.success && processResponse.data) {
            const records = Array.isArray(processResponse.data) ? processResponse.data : []
            this.traceList = records.map(item => {
              const imageUrls = this.parseImageString(item.processUrl)
              return {
                id: item.traceId,
                title: item.processName,
                operator: item.operator,
                time: item.operatingTime,
                image: imageUrls[0] || 'https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115163920A013.png',
                imageUrls: imageUrls,
                codeId: codeId
              }
            })
            console.log('获取加工生产记录列表成功:', this.traceList)
          } else {
            this.traceList = []
          }
        } else {
          this.traceList = []
        }
      } catch (error) {
        console.error('获取溯源列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    // 打开加工生产记录弹窗
    openProcessDialog(trace) {
      this.currentTrace = trace
      this.currentImageIndex = 0
      this.showProcessDialog = true
      // 通知父组件弹窗打开
      this.$emit('modal-open', true)
    },
    
    // 关闭弹窗
    closeProcessDialog() {
      this.showProcessDialog = false
      this.currentTrace = null
      this.currentImageIndex = 0
      // 通知父组件弹窗关闭
      this.$emit('modal-open', false)
    },
    
    // 切换图片
    switchImage(direction) {
      if (!this.currentTrace || !this.currentTrace.imageUrls || this.currentTrace.imageUrls.length === 0) return
      
      if (direction === 'next') {
        if (this.currentImageIndex === this.currentTrace.imageUrls.length - 1) {
          this.currentImageIndex = 0
        } else {
          this.currentImageIndex++
        }
      } else {
        if (this.currentImageIndex === 0) {
          this.currentImageIndex = this.currentTrace.imageUrls.length - 1
        } else {
          this.currentImageIndex--
        }
      }
    }
  }
}
</script>

<style scoped>
.quality-trace {
  padding: 0;
 
}



.header-icon {
  width:20px;
  height:20px;
}

.trace-list {
  padding: 0;
   
}

.trace-item {
  display: flex;
  align-items: center;

  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
  margin-bottom:16px;
  border-radius: 8px;;
}

.trace-item:last-child {
  border-bottom: none;
}

.trace-image {
  width: 90px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right:12px;
}

.trace-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.trace-content {
  text-align: left;


}

.trace-step-title {
  font-size: 16px;
  height:16px;
  font-weight: bold;
  color: #333;
  margin-bottom:12px;
}

.trace-step-operator,
.trace-step-time {
  font-size: 12px;
  color: #999;
}
.trace-step-operator span,
.trace-step-time span {
   font-size: 12px;
  color: #333;
}
.trace-step-operator{
  margin-bottom:3px;
}
.trace-step-tags {
  display: flex;
  padding-top:6px;
  align-items: center;
  /* margin-top: 5px; */
}

.trace-step-tag {

  color: #4191EF;
  margin-right:16px;
  font-size: 12px;
   display: flex;
   align-items: center;
}
.trace-step-tag img{
  width: 16px;
  height: 16px;
  margin-right:2px;
}

/* 弹窗样式 */
.process-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.process-dialog {
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.dialog-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.dialog-close {
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-close img {
  width: 16px;
  height: 16px;
}

.dialog-content {
  padding: 16px;
}

.process-info {
  margin-bottom: 16px;
}

.info-item {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.info-item span {
  color: #333;
  margin-left: 8px;
}

.image-container {
  width: 100%;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.process-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-nav {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
}

.nav-btn {
  width: 32px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.no-records {
  color: #999;
  font-size: 14px;
}

</style>